import { render, staticRenderFns } from "./TeachingClassConfigurationPage.vue?vue&type=template&id=292ac750&scoped=true"
import script from "./TeachingClassConfigurationPage.vue?vue&type=script&lang=js"
export * from "./TeachingClassConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./TeachingClassConfigurationPage.vue?vue&type=style&index=0&id=292ac750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ac750",
  null
  
)

export default component.exports